import { useCreateProviderMutation } from '../../../../graphql'
import useShowSuccess from 'hooks/useShowSuccess'

export default function useCreateProviderHandler() {
	const [ createProvider ] = useCreateProviderMutation( )
	const showSuccess = useShowSuccess()

	return async( provider: { name: string } ) => {
		await createProvider( {
			variables: {
				name: provider.name,
			},
		} )
		 showSuccess( `createProviderSuccess${Date.now()}`, 'Successfully created manufacturer!' )
	}
}
